import React, {memo} from 'react';
import PropTypes from 'prop-types';

const LastExportColumn = memo(({feedExport}) => {
  return (
    <td className="pt-4">
      <div className={'d-flex flex-column justify-content-between'}>
        <div className={'d-flex flex-row justify-content-center'}>
          <span className={'fa fa-calendar fa-regular pe-2'}/>
          <span>{feedExport.lastDay}</span>
        </div>
        <div className={'d-flex flex-row justify-content-center'}>
          <span className={'fa fa-clock fa-regular pe-2'}/>
          <span>{feedExport.lastHour}</span>
        </div>
      </div>
    </td>
  );
});

LastExportColumn.propTypes = {
  feedExport: PropTypes.object.isRequired,
};

export default LastExportColumn;
